import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
`;

// 섹션마다 흰 카드 (에디터 새 디자인과 같은 모양)
export const FragmentListWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

export const DropdownFieldWrapper = styled.div`
    background: #fff;
    border-radius: 16px;
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.06);
    overflow: hidden;
`;